module.exports = __webpack_public_path__ + "assets/roboto-v15-latin-regular-ad7338.woff";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff
// module id = 826
// module chunks = 2